module.exports = __webpack_public_path__ + "img/53.ac3ef2c7.jpeg";